import React, { useState, useEffect } from 'react';
import { IonPage, IonContent, IonRouterLink } from '@ionic/react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Stack, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useFetch } from 'use-http';
import appStrings from '../../common/app_strings';
import appColors from '../../common/app_colors';
import GeneralTextCardAtom from '../../common/atoms/generalTextCardAtom/GeneralTextCardAtom';
import Button from '../../common/atoms/button/Button';

const { startBgCheckScreen } = appStrings;
const { buttons, container, text } = appColors;

const styles = {
  pageContainer: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  contentContainer: {
    flex: 1,
  },
  buttonContainer: {
    padding: '12px',
    marginTop: 'auto',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  secondaryButton: {
    color: buttons.secondaryBackground,
    fontSize: '16px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '12px 0 24px 0',
  },
  cardTitle: {
    textAlign: 'center',
    color: container.darkNavy,
    fontSize: '28px',
    fontWeight: 700,
  },
  cardBody: {
    padding: '16px',
    fontSize: '1rem',
    textAlign: 'center',
    color: text.lightBlack,
    opacity: 1,
  },
  celebrationImage: {
    marginTop: '-40px',
    marginRight: '2.5rem',
    width: '90%',
    maxWidth: '350px',
    height: 'auto',
    objectFit: 'contain',
  },
  checkrInfoContainer: {
    margin: '10px',
    padding: '20px',
    right: '0.5rem',
    alignItems: 'center',
  },
  checkrInfo: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontWeight: '600',
  },
  button: {
    background: container.darkNavy,
    width: '85%',
    fontWeight: 'bold',
    alignSelf: 'center',
    padding: '5px 5px 0px 5px',
    margin: '20px 10px 0px 0px',
    cursor: 'pointer',
  },
  buttonLabel: {
    paddingBottom: '10px',
    fontSize: '20px',
  },
  checkrInfoIcon: {
    paddingRight: '5px',
  },
};

const SecondaryButton = ({ action, label }) => (
  <IonRouterLink onClick={action}>
    <Typography sx={styles.secondaryButton}>{label}</Typography>
  </IonRouterLink>
);

const StartBackgroundCheckScreen = () => {
  const history = useHistory();
  const { get: getTeams, response: getTeamsResponse } = useFetch('/users/teams');
  const [secondaryAction, setSecondaryAction] = useState(null); // "exploreTeam", "maybeLater", "goToFeed"
  const goToBGCheck = () => {
    history.push('/checkr-form');
  };
  const goToTeamDetails = () => {
    history.push('/tabs/backr/teams');
  };

  const goToFeed = () => {
    history.push('/');
  };

  const goBack = () => {
    history.goBack();
  };

  const getSecondaryAction = async () => {
    const teams = await getTeams();
    if (getTeamsResponse.ok) {
      if (teams.length > 0) {
        setSecondaryAction('exploreTeam');
      } else {
        setSecondaryAction('maybeLater');
      }
      return;
    }
    setSecondaryAction('goToFeed');
  };

  useEffect(() => {
    void (async () => {
    await getSecondaryAction();
  })();
  }, []);

  const secondaryButtonProps = () => {
    const goToFeedProps = {
      label: startBgCheckScreen.maybeLater,
      action: goToFeed,
    };

    switch (secondaryAction) {
      case 'exploreTeam':
        return {
          label: startBgCheckScreen.exploreTeam,
          action: goToTeamDetails,
        };
      case 'maybeLater':
        return {
          label: startBgCheckScreen.maybeLater,
          action: goBack,
        };
      case 'goToFeed':
        return goToFeedProps;
      default:
        return goToFeedProps;
    }
  };

  return (
    <IonPage>
      <IonContent style={{ '--padding-top': '70px' }}>
        <Stack sx={styles.pageContainer}>
          <Stack sx={styles.contentContainer}>
            <Stack sx={styles.mainContainer}>
              <GeneralTextCardAtom
                title={startBgCheckScreen.header}
                body={startBgCheckScreen.body}
                titleStyles={styles.cardTitle}
                bodyStyles={styles.cardBody}
              />
              <img
                style={styles.celebrationImage}
                src="/assets/bgCheckCelebration.svg"
                alt="Party favor and clipboard"
              />
              <Stack
                sx={styles.checkrInfoContainer}
              >
                <Stack alignContent="left" gap={1}>
                  {startBgCheckScreen.checkrInfo.map((info) => (
                    <div
                      key={info}
                      style={styles.checkrInfo}
                    >
                      <ArrowForwardIcon sx={styles.checkrInfoIcon} />
                      <span>{info}</span>
                    </div>
                  ))}
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          <Stack sx={styles.buttonContainer}>
            <Button
              label={startBgCheckScreen.startBgCheck}
              buttonStyles={styles.button}
              labelStyles={styles.buttonLabel}
              onClickCallBack={goToBGCheck}
            />
            {secondaryAction !== null && <SecondaryButton {...secondaryButtonProps()} />}
          </Stack>
        </Stack>
      </IonContent>
    </IonPage>
  );
};

export default StartBackgroundCheckScreen;
